import { Component, Input } from '@angular/core'
import { RiskAssessment } from 'src/app/models/Reports'

@Component({
	selector: 'app-evaluation-risk',
	templateUrl: './evaluation-risk.component.html'
})
export class EvaluationRiskComponent {
		@Input() public riskAssessment: RiskAssessment = new RiskAssessment()
}
